<template>
  <div style="padding: 20px;">
    <div class="title">用户注册及使用APP隐私协议</div>
    <div class="wrap">
      <p class="wrapTitle content">导言</p>
      <p class="content">
        1.
        优诺红酒柜APP是一款由杭州金松优诺电器有限公司（注册地为浙江省杭州市钱塘区白杨街道3号大街19号。以下亦简称“我们”或“金松优诺”）提供服务的应用产品。为说明优诺红酒柜APP会如何收集、使用和存储你的个人信息及你享有何种权利，我们将通过本指引向你阐述相关事宜，其中要点如下：
      </p>
      <p class="content">
        2.
        我们将逐一说明我们收集的你的个人信息类型及其对应的用途，以便你了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。
      </p>
      <p class="content">
        3.
        当你使用某些功能时，我们会在获得你的同意后，收集你的敏感个人信息。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使你无法使用相关特定功能，但不影响你正常使用优诺红酒柜APP的其他功能。
      </p>
      <p class="content">
        4.
        我们不会主动共享或转让你的个人信息至杭州金松优诺电器有限公司外的第三方。如存在其他共享或转让你的个人信息，或你需要我们将你的个人信息共享或转让至杭州金松优诺电器有限公司外的第三方情形时，我们会直接征得或确认第三方征得你对上述行为的明示同意，但法律法规另有规定或因保护用户权益或保护优诺红酒柜APP生态安全需要除外。此外，我们会对对外提供信息的行为进行风险评估。
      </p>
      <p class="content">
        5.
        我们不会主动从杭州金松优诺电器有限公司外的第三方获取你的个人信息。如为业务发展需要从第三方获取你的个人信息，我们会依法核实来源的合法性，或在获取前向你明示你个人信息的来源、类型及使用范围，如优诺红酒柜APP开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的该等个人信息前，征得你的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。
      </p>
      <p class="content">
        6.
        你可以通过本指引所列途径及方式查阅、更正、复制、删除你的个人信息，也可以进行注销帐号、投诉举报等隐私功能。
      </p>
      <p class="content">
        7.
        为了在本指引下收集你的信息，或者向你提供服务、优化我们的服务以及保障你的帐号安全，我们将需要向你索取相关的权限；其中的敏感权限例如通讯录、位置、摄像头、麦克风、相册等均不会默认开启，只有在你明确同意后我们才会在你同意的范围内调用或使用。对你已经向我们授权的该等权限，你也可以在“系统—设置—应用权限管理”中查询我们已调用或使用的系统权限类型、使用目的，并进行统一管理。
      </p>
      <p class="content">
        需要特别说明的是，我们获得具体某一项敏感权限并不代表我们必然会收集你的相关信息；即使我们已经获得敏感权限，也仅在必要范围内，并在你使用相关的服务或功能期间根据本指引来收集你的相关信息。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">一、我们收集、使用的信息</p>
      <p class="content">
        在你使用本应用服务的过程中，我们会按照如下方式收集、使用你在使用服务时主动提供或因为使用服务而产生的信息：
      </p>
      <p class="content">
        1.1
        当你注册“优诺红酒柜APP”账号时，我们会收集、使用你的昵称、头像、手机号码，收集这些信息是为了帮助你完成账号注册和使用知识库社交等功能，保护你帐号的安全。收集、使用手机号码是为了满足相关法律法规的真实身份信息认证要求。若你不提供这类信息，你可能无法正常使用我们的服务。你还可以根据自身需求选择填写性别、地区等信息。
      </p>
      <p class="content">
        1.2
        当你使用“优诺红酒柜APP”服务时，为保障你正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全，我们会收集、使用你的操作系统、登录IP地址、优诺红酒柜APP版本号、接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息（如你在应用进行搜索、查看操作的记录、故障信息等信息）等日志信息。
      </p>
      <p class="content">
        1.3
        当你在知识库中发布内容，你设置的名字、头像、性别、地区，你发布的文字、图片、内容，以及你所发布内容包含的元数据等信息将被收集，同时，当你发布视频内容或直播内容，我们会根据你希望使用的功能依场景请求你授权相应功能所需的相机、照片、麦克风或位置权限
        ，若你不同意或取消授权，将无法使用相应功能，但不影响你使用应用其他功能。你可以更改你的名字、头像、性别等信息，删除你发表的内容。
      </p>
      <p class="content">
        1.4 你可以在你的个人信息中填写性别、姓名
        、年龄等，这些信息将被上传并存储在我们的服务器中，以便你在其他设备上登录应用时使用该等信息。你也可以随时修改、删除该等信息。
        ，若你不同意或取消授权，将无法使用相应功能，但不影响你使用应用其他功能。你可以更改你的名字、头像、性别等信息，删除你发表的内容。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">二、信息的存储</p>
      <p class="content">
        2.1 信息存储的地点
      </p>
      <p class="content">
        我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内
        。如果你的个人信息存储地点从中国境内转移到境外的，我们将严格依照法律的规定执行。
      </p>
      <p class="content">
        2.2 信息存储的期限
      </p>
      <p class="content">
        一般而言，我们仅在为实现目的所必需的时间及法律、行政法规所规定的保存期限内保留你的个人信息，例如：
      </p>
      <p class="content">
        手机号码：若你需要使用本应用服务，我们需要一直保存你的手机号码（包括初始注册手机号码、绑定的手机号码等），以保证你正常使用该服务。当你注销帐号后，我们将依法删除相应的信息；
      </p>
      <p class="content">
        知识库信息：当你发布了知识库信息，我们需要保存你的知识库信息，以保证你正常使用知识库功能，当你删除你的知识库信息后，我们将删除相应的信息。
      </p>
      <p class="content">
        当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，并在合理的期限内删除你的个人信息或进行匿名化处理。（本指引中的“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。）
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">三、信息安全</p>
      <p class="content">
        我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、篡改、未经授权访问或披露。
      </p>
      <p class="content">
        我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、去标识化、匿名化处理等手段来保护你的个人信息。
      </p>
      <p class="content">
        我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、网站，我们可能会了解你设备安装的应用信息、正在运行的进程信息或设备内存中寄存的数据；为了预防诈骗、盗号、仿冒他人等不法行为和进行安全检查可能会分析利用唯一设备标识符、登录IP地址、操作日志、位置信息等数据，以便于采取安全措施或进行安全提醒等。
      </p>
      <p class="content">
        我们建立专门的管理制度、操作规程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。
      </p>
      <p class="content">
        若发生个人信息泄露等安全事件，我们会启动应急预案及补救措施，阻止安全事件扩大，并依法履行相关的报告及通知义务。
      </p>
      <p class="content">
        我们会尽力保护你的个人信息。 我们也请你理解，任何安全措施都无法做到无懈可击。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">四、个人信息与权限使用</p>
      <p class="content">
        4.1
        根据相关法律法规及国家标准，以下情形中，我们可能会处理你的相关个人信息而无需征求你的授权同意：
      </p>
      <p class="content">
        a) 为个人信息处理者履行法定义务或法定职责所必需；
      </p>
      <p class="content">
        b) 为订立、履行你作为一方当事人的合同所必需；
      </p>
      <p class="content">
        c) 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
      </p>
      <p class="content">
        d) 依法在合理的范围内处理你自行公开或者其他已经合法公开的个人信息；
      </p>
      <p class="content">
        e) 法律、行政法规规定的其他情形。
      </p>
      <p class="content">
        4.2
        请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中告知收集、使用你的信息的处理规则，我们会通过页面提示、交互流程、网站公告等方式另行向你告知信息收集的范围、目的及方式，以征得你的同意。
      </p>
      <p class="content">
        4.3
        为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息融合处理。
      </p>
      <p class="content">
        4.4
        如我们使用你的个人信息，超出了你所授权的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。
      </p>
      <p class="content">
        4.5
        请你注意，目前“优诺红酒柜APP”不会主动从杭州金松优诺电器有限公司外的第三方获取你的个人信息。如未来为业务发展需要从第三方间接获取你个人信息，我们会在获取前向你明示你个人信息的来源、类型及使用范围，如本应用开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的该等个人信息前，征得你的明示同意。
      </p>
      <p class="content">
        4.6 此外，我们将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">五、对外提供</p>
      <p class="content">
        5.1
        为了投放广告，评估、优化广告投放效果等目的，我们需要向广告主及其代理商等第三方合作伙伴共享你的部分数据，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
      </p>
      <p class="content">
        5.2 我们不会向合作伙伴分享可用于识别你个人身份的信息，除非你明确授权。
      </p>
      <p class="content">
        5.3
        当你在第三方主体运营的网站或者应用中使用“优诺红酒柜APP”登录功能时，我们将向该等第三方主体提供你的个人信息，具体的对外提供范围以交互页面中你确认的为准。除此之外，在未征得你的明示同意前，我们不会向该等第三方主体提供你的个人信息。
      </p>
      <p class="content">
        5.4
        为确保部分独立功能的实现，使你能够使用和享受更多的服务及功能，我们会在应用中嵌入第三方的SDK，我们将审慎评估该等SDK的使用目的。
      </p>
      <p class="content">
        随着我们业务的持续发展，我们有可能进行合并、分立等交易，若涉及个人信息转移的，我们将告知你相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的处理者继续保护你的个人信息。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">六、第三方SDK目录</p>
      <p class="content">
        6.1 极光推送SDK
      </p>
      <p class="content">
        功能：用于实现消息推送（或其他推送）功能
      </p>
      <p class="content">
        收集个人信息：设备标识符（IMEI、IDFA、AndroidID
        MACOAIDUAID等相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、IP
        地址，WiFi信息，基站信息等相关信息
      </p>
      <p class="content">
        极光隐私政策链接：
      </p>
      <p class="content">
        https://www.jiguang.cn/license/privacy
      </p>
      <p class="content">
        6.2 高德开放平台定位SDK
      </p>
      <p class="content">
        功能：实现定位
      </p>
      <p class="content">
        收集个人信息：位置信息（经纬度、精确位置、粗略位置）【通过IP
        地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息获取】、设备标识信息（IMEI、IDFA、IDFV、Android
        ID、MEID、MAC地址、OAID、IMSI、硬件序列号）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统）。
      </p>
      <p class="content">
        隐私权政策链接：
      </p>
      <p class="content">
        https://lbs.amap.com/pages/privacy/
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">七、用户权利</p>
      <p class="content">
        在你使用“优诺红酒柜APP”期间，为了你可以更加便捷地查阅、复制、更正、删除你的个人信息，同时保障你撤回对个人信息处理的同意及注销帐号的权利，我们在产品设计中为你提供了相应的操作设置，你可以参考下面的指引进行操作。此外，我们还设置了投诉举报、请求解释的渠道，你的意见及请求将会得到及时的处理。
      </p>
      <p class="content">
        请注意，不同操作系统、优诺红酒柜软件的不同版本之间，操作设置可能存在差异
        ；此外，为了优化你的使用体验，我们也可能对操作设置进行调整。故如下指引仅供参考，若你对行使相关权利的方式及途径仍有任何疑问的，你可以通过本规则第11条披露的方式与我们联系。
      </p>
      <p class="content">
        7.1 查阅、复制个人信息
      </p>
      <p class="content">
        7.1.1 查阅头像、昵称（即“名字”，下同）、性别、生日等基本信息：
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击头像；
      </p>
      <p class="content">
        3）进行信息查询访问。
      </p>
      <p class="content">
        7.1.2 查阅知识库信息：
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击“知识库”；
      </p>
      <p class="content">
        3）点击“全部方案”以查看全部方案信息，或点击“我的方案”查看个人发布的知识库信息。
      </p>
      <p class="content">
        7.2 删除个人信息
      </p>
      <p class="content">
        7.2.1 删除性别、生日等基本信息：
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击头像；
      </p>
      <p class="content">
        3）删除相关信息。
      </p>
      <p class="content">
        7.2.2 删除知识库：
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击“知识库”；
      </p>
      <p class="content">
        3）点击“我的方案”；
      </p>
      <p class="content">
        4）点击“删除”，并删除知识库信息。
      </p>
      <p class="content">
        7.3 更正个人信息
      </p>
      <p class="content">
        7.3.1 更改头像、昵称、性别、生日：
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击头像；
      </p>
      <p class="content">
        3）进行更正操作。
      </p>
      <p class="content">
        7.4 注销帐号
      </p>
      <p class="content">
        7.4.1 注销应用帐号：
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击头像；
      </p>
      <p class="content">
        3）点击“注销帐号”。
      </p>
      <p class="content">
        注：当你注销帐号后，我们将按照《中华人民共和国网络安全法》等法律法规的规定留存你的相关信息；超出必要保存期限后，我们将删除或匿名化处理你的个人信息。
      </p>
      <p class="content">
        7.5 投诉举报
      </p>
      <p class="content">
        1）进入应用后，点击左上角头像；
      </p>
      <p class="content">
        2）点击“售后热线”；
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">八、变更</p>
      <p class="content">
        我们可能会适时对本指引进行修订。当指引的条款发生重大变更时，我们会在你登录及版本更新时以推送通知、弹窗或其他符合法律要求的适当形式向你展示变更后的指引。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">九、未成年人保护</p>
      <p class="content">
        我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是18周岁以下的未成年人，在使用本应用服务前，应事先取得你的家长或法定监护人的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过第11章中的联系方式与我们联系。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">十、其他</p>
      <p class="content">
        10.1
        金松优诺《隐私政策》是金松优诺统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于优诺红酒柜APP用户。如金松优诺《隐私政策》与本指引存在不一致或矛盾之处，请以本指引为准。
      </p>
      <p class="content">
        10.2
        在优诺红酒柜APP某些具体服务或功能项下，我们可能还会通过交互文案、产品界面或弹窗等方式向你另行告知处理个人信息的目的、方式或范围，若另行告知的内容与本指引不一致的，以另行告知的内容为准。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">十一、用户反馈渠道</p>
      <p class="content">
        我们设立了专门的个人信息保护团队和个人信息保护负责人，如果你对本隐私政策或个人信息保护相关事宜有任何疑问或投诉、建议时，你可以通过以下任一方式与我们联系：
      </p>
      <p class="content">
        1）通过http://www.hzje.cn/与我们联系；
      </p>
      <p class="content">
        2）将你的问题发送至hzjsyn2022@163.com；
      </p>
      <p class="content">
        3）寄到如下地址：浙江省杭州市钱塘区白杨街道3号大街19号杭州金松优诺电器有限公司行政部（收），邮编：310018；
      </p>
      <p class="content">
        我们将尽快审核所涉问题，并在收到你的投诉反馈后的十五天内予以回复。
      </p>
    </div>
    <div class="wrap">
      <p class="wrapTitle content">
        感谢您了解我们的隐私协议！
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Microsoft YaHei';
  color: #5b5b5b;
}
.title {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.wrap {
  margin-bottom: 12px;
  font-size: 14px;
}
.wrapTitle {
  font-weight: bold;
}
.content {
  text-indent: 2em;
  line-height: 18px;
}
</style>
